import { ChangeDetectorRef, Component, Inject, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CodeConversionMstDto, Sgke371aRequest, Sgke371aResponseShishinInputResult } from 'sg-api';
import { SgAriaMessage } from '../../../../../../sg-base/sg-base-shared/models/sg-aria-message';
import { CodeConversionMstService } from '../../../../../../sg-base/sg-base-shared/services/codeConversionMst.service';
import { ResponseMsgUtils } from '../../../../../sg-ke-shared/util/response-msg-utils';
import { Sgke370dDialogData } from '../../models/sgke370d-dialog-data';
import { Sgke370dDialogRetData } from '../../models/sgke370d-dialog-ret-data';
import { UsedSgke371aService } from '../../services/used-sgke371a.service';

@Component({
  selector: 'app-sgke370d-dialog',
  templateUrl: './sgke370d-dialog.component.html',
  styleUrl: './sgke370d-dialog.component.scss'
})
export class Sgke370dDialogComponent implements OnInit, OnDestroy {
  /** メッセージエリア */
  @Output() errorMessageModelArray: Array<SgAriaMessage> = new Array<SgAriaMessage>();

  /** SGKE371Aリクエストフォーム */
  sgke371arequestData: UntypedFormGroup;
  /** 指針入力情報フォーム */
  shishinInputInfo: UntypedFormGroup;
  /** 指針入力登録APIリクエスト */
  requestSgke371a: Sgke371aRequest;
  /** 指針入力登録APIレスポンス_指針入力結果 */
  registResult: Sgke371aResponseShishinInputResult;

  /** コード変換マスタマップ */
  codeMap: Map<string, CodeConversionMstDto[]> = null;

  /** 購読を停止するためのSubject */
  private onDestroy$ = new Subject();

  /**
   * コンストラクタ
   * @param {Sgke370dDialogData} diaData
   * @param {MatDialogRef<Sgke370dDialogComponent>} ref
   * @param {UsedSgke371aService} registService
   * @param {UntypedFormBuilder} fb
   * @param {CodeConversionMstService} codeConvert
   * @param {ResponseMsgUtils} responseMsgUtils
   * @param {ChangeDetectorRef} cd
   * @memberof Sgke370dDialogComponent
   */
  constructor(
    @Inject(MAT_DIALOG_DATA) public diaData: Sgke370dDialogData,
    private ref: MatDialogRef<Sgke370dDialogComponent>,
    public registService: UsedSgke371aService,
    private fb: UntypedFormBuilder,
    private codeConvert: CodeConversionMstService,
    private responseMsgUtils: ResponseMsgUtils,
    private cd: ChangeDetectorRef,
  ) {
    const validator = diaData.energyClscode == '1' ? [Validators.min(0), Validators.max(9999999999), Validators.pattern(/^\d+$/)] : [Validators.min(0), Validators.max(9999999999.9), Validators.pattern(/^\d+(\.\d)?$/)];

    this.shishinInputInfo = this.fb.group({
      // 供給地点特定番号
      suppntSpno: [{ value: diaData.suppntSpno, disabled: true }],
      // 供給停止再開履歴番号
      supplystopresumptionRrkno: [{ value: diaData.supplystopresumptionRrkno, disabled: true }],
      // 供給停止・再開作業種別コード
      supplystopresumptionWorkClscode: [{ value: diaData.supplystopresumptionWorkClscode, disabled: true }],
      // エネルギー種別コード
      energyClscode: [{ value: diaData.energyClscode, disabled: true }],
      // 作業日付
      workdate: [{ value: diaData.supplystopYearmonthdate, disabled: true }],
      // 供給停止時指針
      supplysuspensiontimeShishin: [{ value: diaData.preShishin, disabled: true }],
      // メータ情報一致フラグ
      meterInfoeqFlg: [{ value: diaData.meterInfoIcchiflag, disabled: false }],
      // メータ取替ありフラグ
      meterTorikaeariFlg: [{ value: diaData.meterTorikaeEonflg == '1' ? true : false, disabled: false }],
      // 取外メータ番号
      removalMeterNo: [{ value: diaData.meterTorikaeEonflg == '1' ? diaData.removalMeterNo : null, disabled: diaData.meterTorikaeEonflg == '1' ? false : true }, [Validators.minLength(4), Validators.maxLength(10)]],
      // 取外メータ指針
      removalMeterShishin: [{ value: diaData.meterTorikaeEonflg == '1' ? diaData.duringremovalShishin : null, disabled: diaData.meterTorikaeEonflg == '1' ? false : true }, validator],
      // 取付メータ番号
      installationMeterNo: [{ value: diaData.installationMeterNo, disabled: false }, [ Validators.minLength(4), Validators.maxLength(10)]],
      // 取付メータ指針
      installationMeterShishin: [{ value: diaData.meterTorikaeEonflg == '1' ? diaData.duringinstallationShishin : null, disabled: diaData.meterTorikaeEonflg == '1' ? false : true }, validator],
      // メータ回転ありフラグ
      meterKaitenariFlg: [{ value: diaData.meterRotationEonflg == '1' ? true : false, disabled: diaData.meterTorikaeEonflg == '1' ? false : true }],
      // 今回指針
      thistimeShishin: [{ value: diaData.duringstopShishin ?? null, disabled: diaData.duringstopShishin != null }, validator],
      // 今回指針（確認用）
      thistimeShishinForconfirm: [{ value: diaData.duringstopShishin ?? null, disabled: diaData.duringstopShishin == null }, validator],
    })

    // 指針入力登録APIのFormを初期化
    this.sgke371arequestData = this.fb.group({
      requestCommon: new UntypedFormGroup({}),
      shishinInputInfo: this.shishinInputInfo
    });

  }

  /**
   * 初期処理
   * @memberof Sgke370dDialogComponent
   */
  ngOnInit(): void {

    // コード変換マスタ取得
    const dispItemIdList = [
      'S301241',
    ];
    //コード変換マスタ共通コンポーネント呼び出し
    this.codeConvert.getCodeConversionMst(dispItemIdList)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(codeMap => {
        // ローカルに保存
        this.codeMap = codeMap;
      });

    this.isEnabled();
  }

  /**
   * 購読解除
   * @memberof Sgke370dDialogComponent
   */
  ngOnDestroy() {
    //購読を停止する処理
    this.onDestroy$.next();
    this.sgke371arequestData.clearValidators();
    this.sgke371arequestData.updateValueAndValidity();
  }

  /**
   * 閉じるボタン押下時処理
   * @memberof Sgke370dDialogComponent
   */
  close(): void {
    window.confirm('入力内容が破棄されますが、よろしいですか。') ? this.ref.close() : null;
  }

  /**
   * 登録ボタン押下時処理
   * @memberof Sgke370dDialogComponent
   */
  register() {

    // メッセージクリア
    this.clearErrorMsg();

    // リクエスト情報をもつオブジェクトを定義
    this.requestSgke371a = this.sgke371arequestData.getRawValue() as Sgke371aRequest;
    this.requestConv();

    // SGKE371A呼び出し
    this.registService.doSgke371a(this.requestSgke371a).pipe(takeUntil(this.onDestroy$)).subscribe(
      response => {

        if (response?.shishinInputResult) {
          this.registResult = response.shishinInputResult;
          this.createRetData();
        }

        if (response?.responseCommon?.errors?.length > 0) {
          for (const error of response.responseCommon?.errors) {
            if (response.responseCommon?.resultDetailCode === "SZZZ_N000") {
              // 正常終了（メッセージなし）時処理
              this.ref.close(this.createRetData());
            } else if (response.responseCommon?.resultDetailCode === "SZZZ_W000") {
              // 正常終了（メッセージあり）時処理
              window.confirm(error.message) ? this.ref.close(this.createRetData()) : null;
            } else {
              // メッセージを表示
              this.errorMessageModelArray = this.responseMsgUtils.createResponseMsg(response?.responseCommon?.errors, this.errorMessageModelArray);
            }
          }
        } else {
          // 正常終了（メッセージなし）時処理
          this.ref.close(this.createRetData());
        }
      },
      error => {
      }
    );
  }

  /**
   * リクエストの型変換
   * @memberof Sgke370dDialogComponent
   */
  requestConv() {
    this.requestSgke371a.shishinInputInfo.meterTorikaeariFlg ? this.requestSgke371a.shishinInputInfo.meterTorikaeariFlg = '1' : this.requestSgke371a.shishinInputInfo.meterTorikaeariFlg = '0';
    this.requestSgke371a.shishinInputInfo.meterKaitenariFlg ? this.requestSgke371a.shishinInputInfo.meterKaitenariFlg = '1' : this.requestSgke371a.shishinInputInfo.meterKaitenariFlg = '0';
    this.requestSgke371a.shishinInputInfo.meterInfoeqFlg = this.requestSgke371a.shishinInputInfo.meterInfoeqFlg.toString();
  }

  /**
   * ダイアログ返却値作成
   * @return {*}  {Sgke370dDialogRetData}
   * @memberof Sgke370dDialogComponent
   */
  createRetData(): Sgke370dDialogRetData {
    return {
      /** 前回メータ情報一致フラグ */
      meterInfoIcchiflag: this.shishinInputInfo.get('meterInfoeqFlg').value,
      /** メータ取替有フラグ */
      meterTorikaeEonflg: this.shishinInputInfo.get('meterTorikaeariFlg').value ? '1' : '0',
      /** 取外メータ番号 */
      removalMeterNo: this.shishinInputInfo.get('removalMeterNo').value,
      /** 取外時指針値 */
      duringremovalShishin:
        this.toNumberOrNull(
          this.shishinInputInfo.get('removalMeterShishin').value
        ),
      /** 取付メータ番号 */
      installationMeterNo: this.shishinInputInfo.get('installationMeterNo').value,
      /** 取付時指針値 */
      duringinstallationShishin:
        this.toNumberOrNull(
          this.shishinInputInfo.get('installationMeterShishin').value
        ),
      /** メーター回転有無フラグ */
      meterRotationEonflg: this.shishinInputInfo.get('meterKaitenariFlg').value ? '1' : '0',
      /** 今回指針値 */
      duringstopShishin:
        this.toNumberOrNull(
          this.shishinInputInfo.get('thistimeShishin').value
        ),

      /** 使用量 */
      elecCsp:
        this.toNumberOrNull(this.registResult.elecCsp),
        /** 検針エラーフラグ */
        resultregistrationFinDisableflag: this.registResult.resultregistrationFinDisableflag,
      }
  }
  /** 数値変換 */
  private toNumberOrNull(value: any): number | null {
    return value === null || value === '' || value === undefined
      ? null
      : +value;
  }

  /**
   * 「今回指針」が入力されたら「今回指針(確認用)」をenabledにする
   * ただし入力値がバリデーション条件を満たしていない場合は処理を行わない
   * @param {*} e
   * @memberof Sgke370dDialogComponent
   */
  changeDisabled(e: any) {
    if (e.target.value == null || e.target.value == '') {
      this.shishinInputInfo.get('thistimeShishinForconfirm').disable();
      this.shishinInputInfo.get('thistimeShishinForconfirm').setValue(null);
    } else if (this.shishinInputInfo.controls['thistimeShishin'].valid) {
      this.shishinInputInfo.get('thistimeShishin').disable();
      this.shishinInputInfo.get('thistimeShishinForconfirm').enable();
    }
  }

  /**
   * 「前回メーター情報一致/不一致ラジオボタン」選択時処理
   * @memberof Sgke370dDialogComponent
   */
  onChangeMeterMatch(): void {

    // フォームの値をクリアする
    this.shishinInputInfo.controls['thistimeShishin'].setValue(null);
    this.shishinInputInfo.controls['thistimeShishinForconfirm'].setValue(null);
    // 「今回指針」を未入力状態に戻したため、「今回指針」を活性化させる
    this.shishinInputInfo.controls['thistimeShishin'].enable();
    this.shishinInputInfo.controls['thistimeShishinForconfirm'].disable();

    // 前回メータ情報"一致"を選択した場合、メーター回転ありチェックボックスを活性化させる
    if (this.shishinInputInfo.get('meterInfoeqFlg').value == '1') {
      this.shishinInputInfo.get('meterKaitenariFlg').enable();
      // 前回メータ情報"不一致"を選択した場合、メーター取替ありチェックボックスが選択されていなければメーター回転ありチェックボックスを不活性化させ値をnullにする
    } else if (this.shishinInputInfo.get('meterInfoeqFlg').value == '0') {
      if (this.shishinInputInfo.get('meterTorikaeariFlg').value == '0') {
        this.shishinInputInfo.get('meterKaitenariFlg').setValue(null);
        this.shishinInputInfo.get('meterKaitenariFlg').disable();
      }
    }
  }

  /**
   * 「メーター取替ありチェックボックス」選択時処理
   * @memberof Sgke370dDialogComponent
   */
  onChangeMeterTorikae(): void {
    // 「メーター取替ありチェックボックス」選択状態の場合フォームを有効化、非選択状態の場合無効化
    if (this.shishinInputInfo.get('meterTorikaeariFlg').value == '1') {
      this.shishinInputInfo.get('removalMeterNo').enable();
      this.shishinInputInfo.get('removalMeterShishin').enable();
      this.shishinInputInfo.get('installationMeterShishin').enable();
      this.shishinInputInfo.get('meterKaitenariFlg').enable();
    } else {
      this.shishinInputInfo.get('removalMeterNo').disable();
      this.shishinInputInfo.get('removalMeterShishin').disable();
      this.shishinInputInfo.get('installationMeterShishin').disable();
      this.shishinInputInfo.get('meterKaitenariFlg').disable();
    }

    // フォームの値をクリアする
    this.shishinInputInfo.get('removalMeterNo').setValue(null);
    this.shishinInputInfo.get('removalMeterShishin').setValue(null);
    this.shishinInputInfo.get('installationMeterNo').setValue(null);
    this.shishinInputInfo.get('installationMeterShishin').setValue(null);
    this.shishinInputInfo.get('meterKaitenariFlg').setValue(null);
    this.shishinInputInfo.get('thistimeShishin').setValue(null);
    this.shishinInputInfo.get('thistimeShishinForconfirm').setValue(null);

    // 「今回指針」を未入力状態に戻したため、「今回指針」を活性化させる
    this.shishinInputInfo.get('thistimeShishin').enable();
    this.shishinInputInfo.get('thistimeShishinForconfirm').disable();
  }

  /**
   * エラーメッセージ表示領域をクリア
   * @private
   * @returns {void}
   * @memberof Sgke370dDialogComponent
   */
  private clearErrorMsg(): void {
    this.errorMessageModelArray = new Array<SgAriaMessage>();
    this.cd.detectChanges();
  }

  /**
   * 初期表示時のチェックボックスの表示切替
   */
  private isEnabled() : void {
      
      if (this.shishinInputInfo.get('meterInfoeqFlg').value == '1') {
        this.shishinInputInfo.get('meterKaitenariFlg').enable();
    } else if (this.shishinInputInfo.get('meterInfoeqFlg').value == '0') {
      if (this.shishinInputInfo.get('meterTorikaeariFlg').value == '0') {
        this.shishinInputInfo.get('meterKaitenariFlg').setValue(null);
        this.shishinInputInfo.get('meterKaitenariFlg').disable();
      }
    }
  }


}